const CATEGORIES = ['配信数', '経由売上', '獲得売上'];
const FIELDS = ['session_count', 'conversion_price', 'contribution_price'];
const SEGMENTS = {
  no_cv: '未購入',
  one_cv: '一回購入',
  loyal: '二回以上購入',
  unknown: '不明',
};

angular.module('zc')
  .component('zcSiteReportConversionSegment', {
    templateUrl: '/templates/projects.site_reports/conversion_segment.html',
    bindings: { project: '<' },
    controller: zcSiteReportConversionSegment,
  });

zcSiteReportConversionSegment.$inject = ['$scope', 'ChartV2', 'barChartV2Config'];
function zcSiteReportConversionSegment($scope, ChartV2, barChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    let categories;
    let fields;
    if(vm.project.is_abtest) {
      categories = CATEGORIES;
      fields = FIELDS;
    } else {
      categories = CATEGORIES.slice(0, -1);
      fields = FIELDS.slice(0, -1);
    }
    const chart = new ChartV2(barChartV2Config, { xAxis: { categories } });
    vm.chartConfig = chart.getConfig();
    const segments = _.sortBy(vm.project.thisMonthStat.conversion_segments, segment => {
      if(!segment.conversion_segments.conversion_count) return -1; // Move to the last
      return segment.session_count;
    });
    _.each(segments, segment => {
      const name = SEGMENTS[segment.conversion_segments.conversion_count] || '不明';
      const data = _.map(fields, field => _.get(segment, field));
      chart.addSeries({ stacking: 'percent', name, data });
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.site_reports/conversion_segment.controller.js